import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './SearchTitle.module.less';
import { useNewTaxonomy } from '../../services/useVariation';

function SearchTitle({ title, children }) {
  const isNewTaxonomy = useNewTaxonomy();
  return (
    <div className={clsx(styles.root, 'typography-small')}>
      <div
        className={clsx(styles.wrapper, isNewTaxonomy && styles.isNewTaxonomy)}
      >
        <AnimatePresence exitBeforeEnter initial={false}>
          <motion.h1
            key={title}
            className={styles.title}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {title}
          </motion.h1>
        </AnimatePresence>
      </div>
      {children}
    </div>
  );
}

SearchTitle.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default SearchTitle;
